<header [disableMobileMenu]="true"
        brandImage="../../assets/common/header/logo-randstad.png"
        brandImageAlt="Randstad">
    @if (showOfficeSelector) {
      <office-selector userActions></office-selector>
    } @else {
      <span userActions class="loc" style="color:transparent">__</span>
    }
    <help userActions [compactView]="false"></help>
</header>
<loading-overlay [show]="busy">
    <div class="container-fluid rs-container">
        <div class="container h-100">
            <div class="row h-100 justify-content-center align-items-center">
                <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="row">
                        <div id="homeAppGrid" class="homeContent">
                          @for (appLink of appLinks; track $index) {
                            <app-card [appLink]="appLink" (powerBiDialog)="powerBiDialog()"></app-card>
                          }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</loading-overlay>

<app-powerbi-dialog></app-powerbi-dialog>
